import * as React from 'react';
import { useTheme } from './useTheme';
import { useEffect } from 'react';

type Props = React.PropsWithChildren<{}>;

export const TestThemeSwitcher: React.FC<Props> = ({ children }) => {
  const theme = useTheme();

  useEffect(() => {
    theme.change('ui-default');
  }, []);

  return <>{children}</>;
};
